import { useBreakpoint } from '@ocean/hooks'
import { common } from '@ocean/ui'
import { Shield } from 'components/common'
import oseanShape from 'assets/images/ocean-shape.png'
import {
  Container,
  AnimatedDecorator,
  AnimatedDecoratorProps,
  LogoShape,
} from './AuthDecorator.styled'
import desktopBg from './assets/desktop.jpg'
import mobileBg from './assets/mobile.jpg'

const { Decorator, DecoratorVariant } = common
// TODO: story
type AuthDecoratorProps = {
  children: React.ReactNode
}

const AuthDecorator: React.FC<AuthDecoratorProps & AnimatedDecoratorProps> = ({
  children,
  animated,
}) => {
  const isDesktop = useBreakpoint('sm')

  return (
    <Container>
      {animated && <Shield variant='down' />}
      <AnimatedDecorator
        variant={DecoratorVariant.BackgroundImage}
        animated={animated}
        imageUrl={isDesktop ? desktopBg : mobileBg}
      />
      {isDesktop && <LogoShape src={oseanShape} animated={animated} />}
      <Decorator>{children}</Decorator>
    </Container>
  )
}
export default AuthDecorator
